// extracted by mini-css-extract-plugin
module.exports = {"toast":"EpvMUgl4wu4Nqzn-DOmP4w==","toast-box":"_6Jwv2iIskzlpvQchnJSuzw==","toast-icon":"x7MQgRx69igyrOYdA23tQA==","toast-text":"kzgwipr8Yjldwg6wP1Yuqg=="};